import React from "react";
import { Form } from "react-bootstrap";

function StudentRegistration_stap_5({ register, errors }) {
  return (
    <>
      <h5 className="step-heading">E. Mobility Intent</h5>

      <div className="form_holder">
        <div className="row">
          {/* Study Abroad Objective */}
          <div className="col-md-6">
            <Form.Group className="mb-3">
              <Form.Label>Internship / Study-Abroad Objective *</Form.Label>
              <Form.Control
                placeholder="Internship / Study-Abroad Objective"
                {...register("study_abroad_objective", {
                  required: "Objective is required",
                })}
              />
              {errors.study_abroad_objective && (
                <Form.Text className="text-danger">
                  {errors.study_abroad_objective.message}
                </Form.Text>
              )}
            </Form.Group>
          </div>

          {/* Host Country */}
          <div className="col-md-6">
            <Form.Group className="mb-3">
              <Form.Label>Host Country Selection *</Form.Label>
              <Form.Control
                placeholder="Host Country"
                {...register("country", {
                  required: "Country is required",
                })}
              />
              {errors.country && (
                <Form.Text className="text-danger">
                  {errors.country.message}
                </Form.Text>
              )}
            </Form.Group>
          </div>

          {/* Previous International Experience */}
          <div className="col-md-6">
            <Form.Group className="mb-3">
              <Form.Label>Previous International Experience *</Form.Label>

              <div className="d-flex gap-4 mt-2">
                <Form.Check
                  type="radio"
                  label="Yes"
                  value="1"
                  {...register("previous_international_experience", {
                    required: "Please select an option",
                  })}
                />

                <Form.Check
                  type="radio"
                  label="No"
                  value="0"
                  {...register("previous_international_experience", {
                    required: "Please select an option",
                  })}
                />
              </div>

              {errors.previous_international_experience && (
                <Form.Text className="text-danger">
                  {errors.previous_international_experience.message}
                </Form.Text>
              )}
            </Form.Group>
          </div>
        </div>
      </div>
    </>
  );
}

export default StudentRegistration_stap_5;
